// Get the HTML elements
const transparent_div = document.getElementById('show_hide_unhide');
const div_hide_unhide = document.getElementById('div_hide_unhide');


// Add a click event listener to the div
if (transparent_div && div_hide_unhide) {
  transparent_div.addEventListener('click', function() {
    var __div_height = $('#div_hide_unhide').height();
    var newHeight = __div_height === 110 ? '340px' : '110px';
    $('#div_hide_unhide').animate({ height: newHeight }, 200);
    // Toggle the visibility of the element
      // div_hide_unhide.classList.toggle('expand');
        transparent_div.classList.toggle('expand');
       // $('#div_hide_unhide').toggleClass("expand");    
    
  });
}


// <!-- Initialize Swiper -->
var swiper = new Swiper(".gallery-6-swiper", {
  slidesPerView: "auto",
  spaceBetween: 10,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 40,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 50,
    },
    1200: {
      slidesPerView: 6,
      spaceBetween: 40,
    },
  },
});

var swiper = new Swiper(".collection-5-swiper", {
  slidesPerView: "auto",
  spaceBetween: 10,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 50,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 50,
    },
    1200: {
      slidesPerView: 5,
      spaceBetween: 50,
    },
  },
});
